import { Alert, Box, Button, Stack } from '@mui/material';
import PageContainer from '../layout/PageContainer';
import { useState, SubmitEvent } from 'react';
import useNotifications from '../../hooks/useNotifications/useNotifications';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axiosInstance';
import { useSearchParams } from 'react-router-dom';

export default function CreatePasskey() {
  const notifications = useNotifications();
  const [searchParams] = useSearchParams();

  const { user } = useAuth();

  const [reCaptchaProcessed, setReCaptchaProcessed] = useState(false);
  const [reCaptchaInvalid, setReCaptchaInvalid] = useState(false);
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const [creatingPasskey, setCreatingPasskey] = useState(false);

  const handlePasskeyGeneration = async (event: SubmitEvent) => {
    event.preventDefault();

    if (user) {
      setCreatingPasskey(true);

      try {
        const { data: createPasskeyResult } = await api.post(
          '/create-passkey',
          {
            userId: user.id
          });

        if (createPasskeyResult.createPasskeySuccessful) {
          if (createPasskeyResult.passkeyCreationOptions) {

            const options = PublicKeyCredential.parseCreationOptionsFromJSON(
              JSON.parse(createPasskeyResult.passkeyCreationOptions));

            const credential = await navigator.credentials.create({ publicKey: options });

            const { data: passkeyAttestationResult } = await api.post(
              '/perform-passkey-attestation',
              {
                userId: searchParams.get('userId'),
                credential: JSON.stringify(credential)
              });

            if (passkeyAttestationResult.passkeyAttestationSuccessful) {
              notifications.show(
                'Passkey created successfully.',
                {
                  severity: 'success'
                });
            } else if (passkeyAttestationResult.passkeyAttestationUnsuccessfulReason) {
              notifications.show(
                passkeyAttestationResult.passkeyAttestationUnsuccessfulReason,
                {
                  severity: 'error'
                });
            }
          }
        } else if (createPasskeyResult.createPasskeyUnsuccessfulReason) {
          notifications.show(
            createPasskeyResult.createPasskeyUnsuccessfulReason,
            {
              severity: 'error'
            });
        }
      }
      catch (error: any) {
        notifications.show(
          error.message, {
          severity: 'error',
        });
      }

      setCreatingPasskey(false);

      if (reCaptchaProcessed &&
        !reCaptchaInvalid &&
        user) {

        setReCaptchaProcessed(false);
        setReCaptchaInvalid(false);
        setRefreshReCaptcha(!refreshReCaptcha);
      }
    }
  };

  return <PageContainer
    title="Create Passkey"
  >
    <Box
      component="form"
      onSubmit={handlePasskeyGeneration}
      noValidate
      autoComplete="off"
      sx={{ width: '100%', maxWidth: '500px' }}
    >
      <Box sx={{ width: '100%' }}>
        {reCaptchaProcessed && reCaptchaInvalid ?
          <Alert severity="error">
            reCAPTCHA failed.
          </Alert> :
          <></>
        }
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Button
            type="submit"
            variant="contained"
            size="large"
            color="success"
            loading={creatingPasskey}
            disabled={!user || !reCaptchaProcessed || reCaptchaInvalid}
          >
            Create Passkey
          </Button>
        </Stack>
      </Box>
    </Box>
  </PageContainer>
}
